export const SEARCH_PARAM_KEY_VARIANT = 'variant';
export const SEARCH_PARAM_KEY_TYPE = 'type';
export const SEARCH_PARAM_KEY_LAYOUT = 'layout';
export const SEARCH_PARAM_KEY_SIZE = 'size';
export const SEARCH_PARAM_KEY_DEPTH = 'depth';
export const SEARCH_PARAM_KEY_FRAME_STYLE = 'frame-type';
export const SEARCH_PARAM_KEY_FRAME_COLOR = 'frame-color';
export const SEARCH_PARAM_KEY_FRAME_MAT = 'mat';
export const SEARCH_PARAM_KEY_PIN_COLOR = 'pins-color';
